var exports = {
  "P": "SanitizedHtml__Qnz7b1",
  "r": "wrapping__8RvLdQ",
};

module.exports = exports;
